import { apiPost } from '@/api/api.ts'
import { ITestSession } from '@/api/user/getActiveTestSessions.ts'

export const apiEndTestSession = async (protecteeId: number, sessionId: number) => {
    return await apiPost<ITestSession>(`/protectee/${protecteeId}/test-session/${sessionId}/end`)
}
